import api from '@shared/services/api';
import {
  EventComment,
  EventUpvoteResponse
} from '../types/event.types';

/**
 * Service for handling event-related API calls (comments, upvotes, etc)
 */
export class EventService {
  private static BASE_URL = '/calendar/events';

  /**
   * Get comments for an event with pagination
   */
  static async getEventComments(eventId: string): Promise<EventComment[]> {
    const { data } = await api.get<{ comments: EventComment[] }>(
      `${this.BASE_URL}/${eventId}/comments`
    );
    return data.comments;
  }

  /**
   * Add a comment to an event
   */
  static async addComment(
    eventId: string,
    content: string,
    parentId?: string
  ): Promise<EventComment | null> {
    try {
      const { data } = await api.post<{ comment: EventComment }>(
        `${this.BASE_URL}/${eventId}/comments`,
        { content, parentId }
      );
      return data.comment;
    } catch (error) {
      console.error('Error adding comment:', error);
      return null;
    }
  }

  /**
   * Toggle upvote on a comment
   */
  static async toggleCommentUpvote(eventId: string, commentId: string): Promise<EventUpvoteResponse> {
    const { data } = await api.post<EventUpvoteResponse>(
      `${this.BASE_URL}/${eventId}/comments/${commentId}/upvote`
    );
    return data;
  }

  /**
   * Delete a comment from an event
   */
  static async deleteComment(eventId: string, commentId: string): Promise<void> {
    await api.delete(`${this.BASE_URL}/${eventId}/comments/${commentId}`);
  }
}
